import React, { createContext, useContext, useEffect, useState } from "react";
import { useAuth } from "./auth";

// One-shot in-memory cache for the team-role catalog. Refreshed when the
// authed user changes (login / logout / SuperAdmin TOTP cycle). Children
// of <AdminLayout> read this via useTeamRoles() instead of re-fetching
// the catalog on every route change.
const TeamRoleContext = createContext({
  roles: [],
  navAreas: null,
  defaultRoutes: null,
  ready: false,
});

export function TeamRoleProvider({ children }) {
  const { user, authClient } = useAuth();
  const [data, setData] = useState({ roles: [], navAreas: null, defaultRoutes: null, ready: false });

  useEffect(() => {
    if (!user || !user.totp_verified || !authClient) return;
    let alive = true;
    (async () => {
      try {
        const { data } = await authClient.get("/admin/team-roles");
        if (alive) {
          setData({
            roles: data?.roles || [],
            navAreas: data?.nav_areas || null,
            defaultRoutes: data?.default_routes || null,
            ready: true,
          });
        }
      } catch {
        if (alive) setData((d) => ({ ...d, ready: true }));
      }
    })();
    return () => { alive = false; };
  }, [user?.id, user?.totp_verified, authClient]);

  return <TeamRoleContext.Provider value={data}>{children}</TeamRoleContext.Provider>;
}

export function useTeamRoles() {
  return useContext(TeamRoleContext);
}
